import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import {
  DataListSchoolYear,
  DataListTagGroup,
} from "src/app/shared/models/data-list";
import { KeyValuePair } from "src/app/shared/models/key-value-pair";
import { Lookup } from "src/app/shared/models/lookup";
import { AdministrativeUnit } from "src/app/shared/models/organizations/administrative-unit";
import { UploadModalShortComponent } from "../upload-modal-short/upload-modal-short.component";
import { UploadModalComponent } from "../upload-modal/upload-modal.component";

@Component({
    selector: "app-document-upload-control",
    templateUrl: "./document-upload-control.component.html",
    styleUrls: ["./document-upload-control.component.scss"],
    standalone: false
})
export class DocumentUploadControlComponent implements OnInit, OnDestroy {
  @HostListener("click", ["$event"]) click(evt) {
    console.log("DocumentUploadControlComponent.click", evt);
    this.openModal();
  }

  @Input("text") buttonText: string = "Upload";
  @Input("file-types") allowedFileTypes =
    "TXT, CSV, PDF, DOC, DOCX, ODT, PPTX, PPT, RTF, XLS, XLSX, XLSM, PNG, JPEG, JPG, GIF, BMP, ZIP";
  @Input("type-lookup") documentationTypes: KeyValuePair[];
  @Input("file-name") fileName: string;
  @Input("icon") icon: string;
  @Input("color") color: string;
  @Input("disabled") disabled: boolean = false;
  @Input("available-tags") availableTags: DataListTagGroup[] = [];
  @Input("preselected-tag-ids") preselectedTagIds: string[] = [];
  @Input("is-state-user") isStateUser: boolean = false;

  @Input("available-administrativeUnits") availableAdministrativeUnits: AdministrativeUnit[] = [];
  @Input("document-types") documentTypes: Lookup[] = [];
  @Input("school-years") schoolYears: DataListSchoolYear[] = [];
  @Input("preselected-school-year") preselectedSchoolYear;
  @Input("preselected-document-type") preselectedDocumentType;
  @Input("preselected-administrativeUnit") preselectedAdministrativeUnit;
  @Input("preselected-administrativeUnit-survey-id") preselectedAdministrativeUnitSurveyId = "";
  @Input("preselected-student-id") preselectedStudentId = "";
  @Input("preselected-indicator-type") preselectedIndicatorType = -1;
  @Input("is-school-year-visible") isSchoolYearVisible = true;
  @Input("is-administrativeUnit-visible") isAdministrativeUnitVisible = true;
  @Input("use-short-upload-wizard") useShortUploadWizard = false;
  @Input("is-release-date-visible") isReleaseDateVisible = true;

  @Output() uploaded = new EventEmitter<any>();

  private modalSub: Subscription;

  constructor(protected dialog: MatDialog) {}

  ngOnInit(): void {}

  openModal(files?: File[]) {
    if (this.disabled) {
      return;
    }
    const data = {
      title: "Upload Documentation",
      fileName: this.fileName,
      allowedFileTypes: this.allowedFileTypes,
      documentationTypes: this.documentationTypes,
      availableTags: this.availableTags,
      preselectedTagIds: this.preselectedTagIds,
      isStateUser: this.isStateUser,
      availableAdministrativeUnits: this.availableAdministrativeUnits,
      documentTypes: this.documentTypes,
      schoolYears: this.schoolYears,
      preselectedSchoolYear: this.preselectedSchoolYear,
      preselectedDocumentType: this.preselectedDocumentType,
      preselectedAdministrativeUnit: this.preselectedAdministrativeUnit,
      preselectedFiles: files,
      preselectedAdministrativeUnitSurveyId: this.preselectedAdministrativeUnitSurveyId,
      preselectedStudentId: this.preselectedStudentId,
      preselectedIndicatorType: this.preselectedIndicatorType,
      isSchoolYearVisible: this.isSchoolYearVisible,
      isAdministrativeUnitVisible: this.isAdministrativeUnitVisible,
      isReleaseDateVisible: this.isReleaseDateVisible,
    };

    const dialogRef: any = this.useShortUploadWizard
      ? this.dialog.open(UploadModalShortComponent, {
          data: data,
          width: "728px",
        })
      : this.dialog.open(UploadModalComponent, {
          data: data,
          width: "728px",
        });

    this.modalSub = dialogRef.componentInstance.uploadFiles.subscribe(
      (result: any) => {
        if (result) {
          const formData = new FormData();
          result.formArray.forEach((element) => {
            formData.append("DocumentTitles", element.title);
            formData.append("FileNames", element.file.name);
            formData.append("FileTypes", element.type);
            formData.append("Files", element.file, element.file.name);
          });
          formData.append("Tags", result.selectedTagIds);
          formData.append("SchoolYear", result.selectedSchoolYear);
          formData.append("AdministrativeUnitId", result.selectedAdministrativeUnit);
          formData.append("DocumentType", result.selectedDocumentType);
          formData.append("ReleaseDate", result.selectedReleaseDate);
          formData.append("AdministrativeUnitSurveyId", result.selectedAdministrativeUnitSurveyId);
          formData.append("StudentId", result.selectedStudentId);
          formData.append("IndicatorType", result.selectedIndicatorType);

          console.log("uploadFiles", Object.assign({}, formData));

          this.uploaded.emit({ formData, dialogRef });
        }
      }
    );
  }

  ngOnDestroy(): void {
    if (this.modalSub) this.modalSub.unsubscribe();
  }
}
